<template>
    <div @click="open" class="box attachment-box">
        <div class="file" @mouseleave="show_dropdown = false">
            <i class="has-text-grey icon fas" :class="icon"></i>&nbsp;

            <input
                v-if="renaming"
                v-model="name"
                @keypress.enter="save"
                @click.stop=""
                type="text"
                class="name_input"
                ref="name"/>

            <span v-else class="name">{{ attachment.name }}</span>

            <div v-if="loading || rename.loading" class="loader"></div>

            <div @click.stop="show_dropdown = true" class="fas fa-ellipsis-v action"></div>

            <div class="dropdown is-right" :class="{'is-active': show_dropdown}">
                <div class="dropdown-menu">
                    <div class="dropdown-content">
                        <a v-if="is_editable" @click.stop="start_renaming" class="dropdown-item">
                            <i class="icon fas fa-pen"></i> Rename
                        </a>

                        <a @click.stop="copy" class="dropdown-item">
                            <i class="icon fas fa-copy"></i> Copy file link
                        </a>

                        <a v-if="is_editable"
                            @click.stop="show_confirm = true"
                            class="dropdown-item">

                            <i class="icon fas fa-trash-alt"></i> Remove
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="hint">
            <span class="is-pulled-left">
                <base-datetime :date="attachment.created_at"/>
            </span>

            <span class="is-pulled-right">
                {{size}} mb
            </span>
        </div>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this attachment?"
            @close="show_confirm = false"
            @ok="remove_attachment"/>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { saveAs } from 'file-saver';
import { ATTACHMENTS_DETAIL } from '../../api';
import { auth } from '../../utils/requests';
import clipboard from '../../utils/clipboard';

export default {
    name: 'Attachment',
    props: ['space', 'note', 'is_editable', 'attachment'],
    data() {
        return {
            loading: false,
            renaming: false,
            show_confirm: false,
            show_dropdown: false,
            name: this.attachment.name,
        };
    },
    computed: {
        ...mapState('attachments', ['rename']),
        icon() {
            if (['jpg', 'jpeg', 'png', 'gif', 'psd'].includes(this.attachment.extension)) {
                return 'fa-image';
            }
            if (['mp3', 'wav', 'ogg', 'wma'].includes(this.attachment.extension)) {
                return 'fa-volume-up';
            }
            if (['mp4', 'avi', 'mov', 'mpg', 'wmv', '3gp'].includes(this.attachment.extension)) {
                return 'fa-video';
            }
            return 'fa-file';
        },
        size() {
            // Convert to mega bytes
            return (this.attachment.size / 1000 / 1000).toFixed(1);
        },
    },
    methods: {
        remove_attachment() {
            this.loading = true;
            this.$store.dispatch('attachments/remove', {
                space_id: this.space.id,
                note_id: this.note.id,
                attachment_id: this.attachment.id,
            }).then(() => {
                this.$store.commit('notes/remove_attachment', this.attachment.id);
            });
        },
        open() {
            const url = ATTACHMENTS_DETAIL
                .replace('{space_id}', this.space.id)
                .replace('{note_id}', this.note.id)
                .replace('{attachment_id}', this.attachment.id);

            this.loading = true;
            axios.get(url, { ...auth(), responseType: 'blob' }).then((response) => {
                saveAs(response.data, this.attachment.name);
                this.loading = false;
            });
        },
        copy() {
            clipboard(this.attachment.link);
        },
        start_renaming() {
            this.renaming = true;
            this.show_dropdown = false;
            this.$nextTick(() => this.$refs.name.select());
        },
        save() {
            this.$store.dispatch('attachments/rename', {
                attachment_id: this.attachment.id,
                space_id: this.space.id,
                note_id: this.note.id,
                name: this.name,
            }).then(() => {
                this.renaming = false;
                this.$store.commit('notes/rename_attachment', {
                    attachment_id: this.attachment.id,
                    name: this.name,
                });
            });
        },
    },
};
</script>

<style scoped>
    .attachment-box {
        margin-bottom: 1rem;
        padding: 0.8rem;
    }

    .name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: calc(100% - 1rem);
    }

    .name_input {
        font-size: 1.02em;
        border: none;
        width: calc(100% - 1rem);
        outline-width: 0;
        border-bottom: 1px solid #dbdbdb;
    }

    .hint {
        font-size: 0.8em;
        line-height: 0.4rem;
        color: #7a7a7a;
        margin-top: 0.8rem;
        margin-bottom: 1.3rem;
    }

    .action {
        padding: 0 0.3rem;
        cursor: pointer;
    }
</style>
